export default __webpack_public_path__ + "static/emobility-32d2a1f4c9993688b15c4e9a6d0f38d1.jpg";